import style from './button-social.scss';

const script = () => {
  const cssClass: string = 'ButtonSocial';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Do your stuff here
  }
};

export {
  style,
  script,
};
